import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Vehicle } from './vehicle/vehicle.component'
import ImageMotorcycle from './assets/tw/motorcycle.svg'
import ImageVan from './assets/tw/van.svg'
import ImageMtruck from './assets/tw/mtruck.svg'

const VehicleListTW = ({ estimations, quoteInProgress }) => {
  const [t] = useTranslation()

  const motorcycleFee = estimations.motorcycle || t('text__body__minimum_fee__motocycle')
  const vanFee = estimations.van || t('text__body__minimum_fee__van')
  const mtruckFee = estimations.mtruck || t('text__body__minimum_fee__truck_3_5t')

  const defaultFee = Object.keys(estimations).length === 0

  return (
    <>
      <Vehicle
        image={ImageMotorcycle}
        name={t('common__vehicle__motorcycle')}
        description={t('text__body__vehicle_description__motorcycle')}
        fee={motorcycleFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageVan}
        name={t('common__vehicle__van')}
        description={t('text__body__vehicle_description__van')}
        fee={vanFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageMtruck}
        name={t('common__vehicle__truck_3_5t')}
        description={t('text__body__vehicle_description__truck_3_5t')}
        fee={mtruckFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
    </>
  )
}

VehicleListTW.propTypes = {
  estimations: PropTypes.object,
  quoteInProgress: PropTypes.bool,
}

export { VehicleListTW }
